import { CANAIS_DE_ACESSO, type CanaisDeAcesso, type CanalDeAcesso } from '@orbind/core'

/**
 * A regra de QUANDO e COMO barrar o canal (SPEC-20261008-1104-canais-de-acesso).
 *
 * Fora do componente porque é a parte que dá para errar em silêncio — barrar
 * quem pode entrar, ou deixar passar quem não pode — e a única testável sem
 * navegador.
 */
export type Bloqueio =
  | null
  /** O desktop está liberado e a pessoa está fora dele: oferecer o download. */
  | { tipo: 'usar-desktop'; liberados: CanalDeAcesso[] }
  /** O canal atual não está liberado e o desktop também não. */
  | { tipo: 'canal-fechado'; liberados: CanalDeAcesso[] }

export function bloqueioDoCanal(permitidos: CanaisDeAcesso | undefined, atual: CanalDeAcesso): Bloqueio {
  // sessão sem a informação (servidor antigo): não barra ninguém
  if (!permitidos || permitidos[atual]) return null
  const liberados = CANAIS_DE_ACESSO.filter((c) => permitidos[c])
  return permitidos.desktop ? { tipo: 'usar-desktop', liberados } : { tipo: 'canal-fechado', liberados }
}
